module.exports = __webpack_public_path__ + "media/images/landing/browser_planning.es-df8c196e30ae4d4a6e2a459de8e786bb.png";